
export default {
    STUDENT_SIDE: {
        ATTEMPTED_TEST_LIST: {
            url: (payload) => {
                let search = "";
                if(payload.search) search = `&search=${payload.search}`;
                return `/shared-test/attempted-list?limit=${payload.limit}&offset=${payload.offset}${search}`;
            },
            method: "GET",
            params: []
        },
        FREE_TEST_LIST: {
            url: (payload) => {
                let search = "",isUpcoming="";
                if(payload.search) search = `&search=${payload.search}`;
                if(payload.isUpcoming) isUpcoming=`&isUpcoming=true`;
                return `/shared-test/free-list?limit=${payload.limit}&offset=${payload.offset}${search}${isUpcoming}`
            },
            method: "GET",
            params: []
        },
        STUDENT_TEST_DETAILS: {
            url: (payload) => `/stats/student-test`,
            method: "GET",
            params: []
        },
    }
};
